<script setup lang="ts">
import type { YearBreakdownEntry } from '@open-songster/shared'

interface Props {
  breakdown: YearBreakdownEntry[]
}

const props = defineProps<Props>()
</script>

<template>
  <div class="stack" style="--stack-gap: var(--space-2)">
    <h2 class="title-md">{{ $t('playlist.breakdownTitle') }}</h2>
    <p class="hint">{{ $t('playlist.breakdownHint') }}</p>
    <p v-if="props.breakdown.length === 0" class="muted">{{ $t('playlist.resolving') }}</p>
    <ul v-else class="cluster breakdown">
      <li
        v-for="entry of props.breakdown"
        :key="entry.year"
        class="year-chip"
        :class="entry.qualifying ? 'year-chip--qualifying' : 'year-chip--excluded'"
        :title="entry.qualifying ? $t('playlist.qualifying') : $t('playlist.notQualifying')"
      >
        <span class="mono">{{ entry.year }}</span>
        <span class="faint">{{ entry.trackCount }}</span>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.breakdown {
  list-style: none;
  padding: 0;
  margin: 0;
}

/* `.year-chip` already centres its contents; a `baseline` override here left
   the year and the count sitting high in the pill. */
</style>
